import { match } from 'ts-pattern'
import { Hex } from 'viem'
import { NetworkId } from '@/types/network'

export function getPepperTreasuryBalanceAddress(chainId: NetworkId) {
	const address = match(chainId)
		// Spicy
		.with(88882, () => '0xcf702d6b1DbbcBE03e0b417eA5e3617Bb9584D79') // Using the same as Staging for now
		// Staging
		.with(88883, () => '0xcf702d6b1DbbcBE03e0b417eA5e3617Bb9584D79')
		// Mainnet
		.with(88888, () => '0x26Ed279F6d9F1bb016f16e75704E6bBCc1F99213') // PEPPER MainDAO on Aragon
		.exhaustive()

	return address as Hex
}
